import { render, staticRenderFns } from "./employeeInsert.vue?vue&type=template&id=272d8488&scoped=true&"
import script from "./employeeInsert.vue?vue&type=script&lang=js&"
export * from "./employeeInsert.vue?vue&type=script&lang=js&"
import style0 from "./employeeInsert.vue?vue&type=style&index=0&id=272d8488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d8488",
  null
  
)

export default component.exports